import api from '../httpClient';
import type { CourseCompletionData, CourseProgressData } from '../../types';

interface GetFlowByNameOptions {
  courseId?: number | null;
}

export const courseService = {
  getAll: () => api.get('/api/courses/'),
  get: (id: number) => api.get(`/api/courses/${id}/`),
  getFlows: (id: number) => api.get(`/api/courses/${id}/flows/`),
  getFlowByName: (flowName: string, options: GetFlowByNameOptions = {}) => {
    const params =
      typeof options.courseId === 'number' && Number.isFinite(options.courseId)
        ? { course_id: options.courseId }
        : undefined;
    return api.get(`/api/courses/flow/${encodeURIComponent(flowName)}/`, { params });
  },
  getCourseProgress: (courseId: number) =>
    api.get<CourseProgressData>(`/api/courses/${courseId}/progress/`),
  getCourseCompletion: (courseId: number) =>
    api.get<CourseCompletionData>(`/api/courses/${courseId}/completion/`),
};
